import { useTelemetry } from '@figure/frontlib-growth';
import { isFigure } from 'shared/utils/ThemeHelper';

export default () => {
  const { telemetry } = useTelemetry();
  return {
    telemetry: isFigure ? telemetry : () => {},
  };
};
